export default "__VITE_ASSET__k4AbrK9K__"